/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Meta_DescInputs */

const en_pc_online_meta_desc = /** @type {(inputs: Pc_Online_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use PdfCraft online for free: open, search, combine, split and save PDFs in your browser with the PdfCraft web app. Files stay on your device and are never uploaded.`)
};

const zh_pc_online_meta_desc = /** @type {(inputs: Pc_Online_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线使用 PdfCraft：在浏览器中用 PdfCraft 网页版打开、搜索、合并、拆分和保存 PDF。文件只在你的设备上处理，绝不上传。`)
};

/**
* | output |
* | --- |
* | "Use PdfCraft online for free: open, search, combine, split and save PDFs in your browser with the PdfCraft web app. Files stay on your device and are never u..." |
*
* @param {Pc_Online_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_meta_desc = /** @type {((inputs?: Pc_Online_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_meta_desc(inputs)
	return zh_pc_online_meta_desc(inputs)
});
export { pc_online_meta_desc as "pc.online.meta_desc" }